/**
 * <maliki-buybar>: phone/tablet buy bar on the product page.
 * Appears once the main purchase form scrolls out of view; its button presses the page's own
 * "Comprar" button (so the chosen variant and quantity are respected) or, when that button is
 * not available (sold out, restock alert), scrolls back to the purchase form.
 */
class MalikiBuybar extends HTMLElement {
  connectedCallback() {
    this.form = document.querySelector('s-product-form[data-product-form]');
    this.button = this.querySelector('[data-buybar-action]');
    if (!this.form || !this.button) return;

    this.observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', passed);
      this.inert = !passed;
    });
    this.observer.observe(this.form);

    this.onClick = () => {
      const add = this.form.querySelector('button[name="add"]:not([disabled])');
      if (add) {
        add.click();
      } else {
        this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.button?.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('maliki-buybar')) customElements.define('maliki-buybar', MalikiBuybar);
